module.exports = __webpack_public_path__ + "static/media/google-play-badge.5e01637f.svg";